import { ApiService } from "./AbstractApiService";
import { IEmail } from "@/interfaces/iEmails";
import { IPageModel } from "@/interfaces/iPageModel";
import API from "./handlers/base.service";
import qs from "qs";
export class EmailAPI extends ApiService {
  public static getInstance() {
    if (!this.instance) {
      this.instance = new this();
    }
    return this.instance;
  }

  private static instance: EmailAPI | null;
  constructor() {
    super("notification");
  }
  public async getEmailsList(
    queryParams?: Record<string, string | number>
  ): Promise<IPageModel<IEmail>> {
    const params = this.transformDateRangeParams(queryParams ?? {});
    return this.get("emails", {
      params,
      paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
    }).then((response) => response.data);
  }
  // public async resendEmail(
  //   params?: Record<string, string | number>
  // ): Promise<IPageModel<IEmail>> {
  //   return this.get("emails/" + params?.webId + "/resendEmail", params).then(
  //     (response) => response.data
  //   );
  // }

  // public async addLookup(
  // payload?: Record<string, string | number>,
  // edit?: boolean
  // ): Promise<IPageModel<IEmail>> {
  // if (edit) {
  //     return this.put("lookups/" + payload?.webId, payload).then(
  //     (response) => response.data
  //     );
  // } else {
  //     return this.post("lookups", payload).then((response) => response.data);
  // }
  // }
  public transformDateRangeParams(
    params: Record<string, string | number>
  ): Record<string, string | number> {
    if (
      params &&
      params["startDate"] &&
      `${params["startDate"]}`.split(",").length > 1
    ) {
      const dates = `${params["startDate"]}`.split(",");
      params["startDate"] = dates[0];
      params["endDate"] = dates[1];
    }
    // eslint-disable-next-line @typescript-eslint/no-unused-vars
    const { ...rest } = params;
    return rest;
  }
  public bulkDeleteEntity(params: number[]) {
    return this.service
      .delete(`notification/emails`, { data: params })
      .then((response) => response.data);
  }
  public resendEmail(webId: number) {
    return this.service
      .put(`notification/` + webId + "/resendEmail")
      .then((response) => response.data);
  }
  public markEmailRead(webId: string) {
    return this.service
      .put(`notification/markEmailsRead/` + webId)
      .then((response) => response.data);
  }
  // public async getLookupModelList(
  // params?: Record<string, string | number>
  // ): Promise<IPageModel<ILookupDataModel>> {
  // return this.get(`lookupsData`, {
  //     params,
  //     paramsSerializer: (p) => qs.stringify(p, { arrayFormat: "comma" }),
  // }).then((response) => response.data);
  // }

  // public async addLookupModelList(
  // payload?: Record<string, string | number>,
  // edit?: boolean
  // ): Promise<IPageModel<ILookupDataModel>> {
  // if (edit) {
  //     return this.put(`lookupsData/` + payload?.webId, payload).then(
  //     (response) => response.data
  //     );
  // } else {
  //     return this.post(`lookupsData`, payload).then(
  //     (response) => response.data
  //     );
  // }
  // }
  //   public async addLookupLang(
  //     payload?: Record<string, string | number>,
  //     edit?: boolean
  //   ): Promise<IPageModel<ILookupLangModel>> {
  //     if (edit) {
  //       return this.put(`lookupsLang/` + payload?.webId, payload).then(
  //         (response) => response.data
  //       );
  //     } else {
  //       return this.post(`lookupsLang`, payload).then(
  //         (response) => response.data
  //       );
  //     }
  //   }
}

export async function getEmails<T extends string>(
  url: string
): Promise<Array<Record<any, any>>> {
  return API.get(url).then((res) => {
    return res.data;
  });
}

export function convertEmailsToFilters<T extends string>(
  emails: Array<Record<any, any>>,
  key: string,
  value: string
) {
  const filters = emails?.map((item) => {
    return {
      label: item[key],
      value: item[value],
    };
  });
  return filters;
}

export async function getEmailFilters(url: string, key: string, value: string) {
  const emails = await getEmails(url);
  return convertEmailsToFilters(emails, key, value);
}
